<template>
    <div class="col-lg-4 col-md-6">
        <div class="post-block to-buy-list">
            <a v-if="network" :href="ad.full_url" target="_blank"></a>
            <a v-else :href="route('minisite.show.ad', ad.id)"></a>
            <img :src="require('@assets/images/misc/booked-flag.png').default" v-if="ad.is_booked && !ad.is_solded" alt="Réservé" style="position: absolute; top: 0; left: 0; z-index:2; width:300px;max-width:50vw;">
            <img :src="require('@assets/images/misc/sold-flag.png').default" v-if="ad.is_solded" alt="Vendu" style="position: absolute; top: 0; left: 0;z-index:2; width:300px;max-width:50vw;">

            <div class="thumbnail" v-lazy-background="ad.first_photo_thumb"></div>
            <div class="like-button" :class="{fav:inFavorites}" @click="addToFavoris"></div><!-- ajout de fav -->
            <!-- Share Button with Dropdown -->
            <ShareButton :ad="ad"/>
            <div class="main-content">
                <div class="price-tag">
                    <div class="price-tag-container">
                        <img :src="require('@assets/images/misc/fiable-ou-rembourse.svg').default" v-if="ad.is_reliable_or_refunded" alt="Logo Fiable ou remboursé" class="ad-logo-reliable-label">
                        {{ ad.price_format }} €
                    </div>
                </div>
                <p class="sub right">
                    <template v-if="ad.lenbox">
                        Dès <span class="primary">{{ mensualite_72 }}€</span>/mois*
                    </template>
                    <template v-else>
                        <span>&nbsp;</span>
                    </template>
                </p>
                <p class="title post-title">{{ ad.make }} {{ ad.model }}</p>
                <p class="version">{{ ad.version }}</p>
                <div class="features">
                    <p>
                        <b>{{ km }} Km</b>
                        <span class="primary">|</span>
                        <b>{{ ad.year }}</b>
                        <span class="primary">|</span>
                        <b>{{ ad.energy }}</b>
                        <span class="primary">|</span>
                        <b>{{ ad.gear }}</b>
                    </p>
                </div>
                <p class="sub center">
                    <template v-if="ad.lenbox">
                        * Dès {{ ad.lenbox.mensualite_72 }}€/mois voir les modalités
                    </template>
                </p>
            </div>
        </div>
    </div>


</template>

<script>
import {Link} from '@inertiajs/inertia-vue3'
import _ from "lodash";
import lazyBackground from '@/helpers/lazy-background';
import ShareButton from '@/Pages/Partials/ShareButton';

export default {
    components: {
        Link,
        ShareButton,
    },
    props: {
        ad: Object,
        network: Boolean,
        favoris: Array,
    },
    directives: {
        'lazy-background': lazyBackground
    },
    data() {
        return {

            form: this.$inertia.form({
                id: this.ad.id,
            }),

            inFavorites: false,
        };
    },
    watch: {
        favoris: {
            deep: true,
            immediate: true,
            handler(newVal, oldVal) {
                this.refreshFavoris();
            }
        }
    },
    methods: {
        refreshFavoris() {
            if (this.favoris) {
                this.inFavorites = this.favoris.includes(this.ad.id);
            }
        },
        addToFavoris() {
            this.inFavorites = !this.inFavorites;
            // on ajoute au favoris

            //axios.post('https://wvw.ewigo.com/favoris', {
            axios.post(route('api.favoris.post'), {
                id: this.ad.id,
            })
                .then((response) => {
                    //this.currentStep = 4
                    console.log(response)
                    //this.autobizData = response.data
                })
/*
            this.form.post('https://wvw.ewigo.com/favoris', {
            //this.form.post(route('api.favoris.post'), {
                preserveScroll: true,
                onSuccess: (response) => {
                    //alert('addtofavorite');

                },
                onError: (e) => {
                    console.log(e)
                }
            })

 */
        },
    },
    computed: {
        mensualite_72() {
            return new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 }).format(this.ad.lenbox.mensualite_72)
        },
        km() {
            return this.ad.kms.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            //return new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 }).format(this.ad.kms)//
        },
    }
}
</script>
<style scoped>
.version {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    /* width: 20em; */
}
.share-button {
    width: 30px;
    height: 30px;
    cursor: pointer;
    position: absolute;
    top: 20px;
    right: 70px;
    transition: all 0.4s ease 0s;
    z-index: 11;
}

</style>
